var _excluded = ["color", "customColor", "customTextColor", "backgroundImage", "spacingSpace", "hasCloseButton", "onCloseClick", "children", "hasBorderRadius", "hasBorder"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import { pageGutterSpace, zIndex } from "../../../settings";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import { getBackgroundByTextColor, getCustomColor } from "../../../utils/getCustomColor";
import getIconColor from "../../../utils/getIconColor";
import isRetina from "../../../utils/isRetina";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
import Button from "../../quarks/Button";
import { sizesSpace } from "../ContainerOrg";
import { defaultProps } from "./BarOrg.props";
var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.741 10.26.667l-4.26 4.259L1.742.666.667 1.742 4.926 6l-4.26 4.26 1.075 1.073L6 7.074l4.259 4.26 1.074-1.075L7.074 6l4.26-4.259Z"
  }));
};
CloseSvg.defaultProps = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconWidth = 12;
var closeButtonWidth = iconWidth + 2 * pageGutterSpace * spaceFactor;
var Container = styled.div.withConfig({
  componentId: "sc-2u2ysp-0"
})(function (_ref) {
  var $backgroundImage = _ref.$backgroundImage,
    $color = _ref.$color,
    theme = _ref.theme,
    $customColor = _ref.$customColor,
    $hasBorderRadius = _ref.$hasBorderRadius,
    $hasBorder = _ref.$hasBorder;
  return css(["display:flex;z-index:", ";align-items:center;background:", ";", " ", ";", ";"], zIndex.PageHeaderOrgMain, $customColor || getColor(theme, $color), $backgroundImage ? css(["background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:center;"], isRetina && $backgroundImage.retinaSrc ? $backgroundImage.retinaSrc : $backgroundImage.src) : null, $hasBorderRadius ? css(["border-radius:", ";"], getBorderRadius(theme, "large2")) : null, $hasBorder ? css(["border:", " solid ", ";"], unit(1), getBorderColor(theme, $color, "extraLow")) : null);
});
var spacingSpaceStyles = function spacingSpaceStyles($spacingSpace) {
  if (typeof $spacingSpace === "number") {
    return css(["padding:", ";"], space($spacingSpace));
  }
  return css(["padding:", " ", ";"], space($spacingSpace.y), space($spacingSpace.x));
};
var Content = styled.div.withConfig({
  componentId: "sc-2u2ysp-1"
})(function (_ref2) {
  var $spacingSpace = _ref2.$spacingSpace,
    $hasCloseButton = _ref2.$hasCloseButton;
  return css(["flex-grow:1;max-width:", ";margin:0 auto;", " ", ""], space(sizesSpace["default"]), spacingSpaceStyles($spacingSpace), $hasCloseButton && css(["padding-right:0;"]));
});
var CloseIcon = styled(CloseSvg).withConfig({
  componentId: "sc-2u2ysp-2"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["fill:", ";"], getIconColor(theme, $onColor));
});
var CloseButton = styled(Button).withConfig({
  componentId: "sc-2u2ysp-3"
})(function (_ref4) {
  var $onColor = _ref4.$onColor,
    theme = _ref4.theme;
  return css(["display:flex;flex-shrink:0;align-items:center;align-self:stretch;justify-content:center;width:", ";&:hover{", "{fill:", ";}}"], unit(closeButtonWidth), CloseIcon, getIconColor(theme, $onColor, "high", "hover"));
});
var BarOrg = function BarOrg(_ref5) {
  var _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? defaultProps.color : _ref5$color,
    customColor = _ref5.customColor,
    customTextColor = _ref5.customTextColor,
    backgroundImage = _ref5.backgroundImage,
    _ref5$spacingSpace = _ref5.spacingSpace,
    spacingSpace = _ref5$spacingSpace === void 0 ? defaultProps.spacingSpace : _ref5$spacingSpace,
    hasCloseButton = _ref5.hasCloseButton,
    onCloseClick = _ref5.onCloseClick,
    children = _ref5.children,
    hasBorderRadius = _ref5.hasBorderRadius,
    hasBorder = _ref5.hasBorder,
    restProps = _objectWithoutProperties(_ref5, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var $customColor = customColor ? getCustomColor(customColor) : undefined;
  var $backgroundColor = getBackgroundByTextColor(customTextColor);
  var handleCloseButtonClick = function handleCloseButtonClick(event) {
    event.preventDefault();
    setIsHidden(function (value) {
      return !value;
    });
    if (onCloseClick) {
      onCloseClick();
    }
  };
  if (isHidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container, _extends({
    $backgroundImage: backgroundImage,
    $color: color,
    $customColor: $customColor,
    $hasBorder: hasBorder,
    $hasBorderRadius: hasBorderRadius
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: $backgroundColor || color
  }, /*#__PURE__*/React.createElement(Content, {
    $spacingSpace: spacingSpace,
    $hasCloseButton: !!hasCloseButton
  }, children)), hasCloseButton ? /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleCloseButtonClick,
    $onColor: $backgroundColor || color
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    $onColor: $backgroundColor || color
  })) : null);
};
export default BarOrg;